import React from "react";
import { Link } from "react-router-dom";
import DownloadButtonsGroup from "./DownloadButtonsGroup";
import * as FaIcons from "react-icons/fa";
import { FaThreads } from "react-icons/fa6";
import { FaTiktok } from "react-icons/fa";

interface FooterProps {
  onLearnMoreClick?: () => void;
  onSignUpClick?: () => void;
}

const Footer: React.FC<FooterProps> = ({ onLearnMoreClick, onSignUpClick }) => (
  <footer className="w-full pt-16 pb-8 bg-[#000000] border-t border-white/10">
    <div className="max-w-6xl mx-auto flex flex-col gap-8 px-4">
      <div className="flex flex-col gap-8 w-full sm:grid sm:grid-cols-3 sm:gap-0 sm:items-start">
        {/* Logo and buttons */}
        <div className="flex flex-col items-center sm:items-start gap-4 min-w-[160px]">
          <img src="/ammopantryai.svg" alt="AmmoPantryAI Logo" className="h-16 w-36 mb-2" style={{ filter: 'invert(1)' }} />
          <div className="flex flex-row gap-3 mb-2 w-full justify-center sm:justify-start">
            <DownloadButtonsGroup variant="white" />
          </div>
        </div>
        {/* Legal */}
        <div className="flex flex-col items-center gap-2 min-w-[120px] sm:justify-center sm:items-center">
          <div className="font-bold text-base mb-2 text-white">Legal</div>
          <Link to="/privacy-policy" className="text-[#a3a3a3] hover:text-[#3b82f6] transition mb-1 text-sm">Privacy Policy</Link>
          <Link to="/terms-of-use" className="text-[#a3a3a3] hover:text-[#3b82f6] transition mb-1 text-sm">Terms of Use</Link>
          <Link to="/delete-account" className="text-[#a3a3a3] hover:text-[#3b82f6] transition mb-1 text-sm">Delete Account</Link>
        </div>
        {/* Company */}
        <div className="flex flex-col items-center sm:items-end gap-2 min-w-[120px] sm:justify-center">
          <div className="font-bold text-base mb-2 text-white">Company</div>
          <Link to="/contact" className="text-[#a3a3a3] hover:text-[#3b82f6] transition mb-1 text-sm">Contact</Link>
        </div>
      </div>
      {/* Bottom row */}
      <div className="flex flex-col md:flex-row justify-between items-center mt-4 gap-4 border-t border-white/10 pt-6">
        <div className="text-sm text-[#a3a3a3]">© Copyright 2026, All rights reserved — AmmoPantryAI</div>
        <div className="flex items-center gap-4">
          <a href="https://www.instagram.com/ammo_pantry/?hl=en" target="_blank" rel="noopener noreferrer"
            className="text-[#a3a3a3] hover:text-[#3b82f6] transition" aria-label="Instagram">
            <FaIcons.FaInstagram className="text-xl" />
          </a>
          <a href="https://www.threads.net/@ammo_pantry" target="_blank" rel="noopener noreferrer"
            className="text-[#a3a3a3] hover:text-[#3b82f6] transition" aria-label="Threads">
            <FaThreads className="text-xl" />
          </a>
          <a href="https://www.tiktok.com/@ammo_pantry" target="_blank" rel="noopener noreferrer"
            className="text-[#a3a3a3] hover:text-[#3b82f6] transition" aria-label="TikTok">
            <FaTiktok className="text-xl" />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
